/**
 * Constants for the cart required-slot autofill (HITL-1551).
 */

/** `CONSTRAINT_DEFAULT_FALLBACK_ITEM` (gpt-context-approach
 * `src/utils/constants.py:6812`) — a per-constraint `conditions` tag of the form
 * `constraint_default_fallback_item:<value>`. `parseModifierGroup` parses the
 * other condition tags onto the modifier group but not this one, so the fill
 * reads it off the brand-menu constraint itself. */
export const CONSTRAINT_DEFAULT_FALLBACK_ITEM =
  'constraint_default_fallback_item';
